
export default {
  path: 'scoreinput',
  name: 'admin.event.discipline.scoreinput',
  component: () => import(/* webpackChunkName: "admin" */ 'client/admin/event/scoreinput/scoreWrapper.vue'),
};
